import domtoimage from 'dom-to-image'
import { logout } from '../redux/auth/actions'
import logoutIcon from '../assets/img/navbarIcons/logout.svg'
import saveIcon from '../assets/img/navbarIcons/download.svg'
import cartIcon from '../assets/img/icons/SHOPPING (1).svg'
import { uploadPlan } from '../redux/user/actions'

const config = [
    {
        name: 'cart',
        image: cartIcon,
        tooltip: 'سبد خرید',
        onClick: (dispatch) => {
            window.location.href = '/#/cart'
        },
        showCartBadge: true,
    },
    {
        name: 'logout',
        image: logoutIcon,
        tooltip: 'خروج',
        onClick: (dispatch) => {
            dispatch(logout())
        },
    },
    {
        name: 'save',
        image: saveIcon,
        isButton: true,
        title: 'ذخیره عکس',
        style: { order: 1 },
        isEditorOnly: true,
        onClick: (dispatch) => {
            var node = document.getElementById('main-scene')

            setTimeout(() => {
                domtoimage
                    .toPng(node)
                    .then(function (dataUrl) {
                        var link = document.createElement('a')
                        link.download = `mokabber_plus_${Date.now()}.jpeg`
                        link.href = dataUrl
                        link.click()
                        dispatch(uploadPlan(dataUrl))
                    })
                    .catch(function (error) {
                        console.error('oops, something went wrong!', error)
                    })
            }, 1000)
        },
    },
]

export default config
